import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, COMPANY } from "../data/site";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/90 backdrop-blur-xl border-b border-border shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 h-[76px] flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link"><Logo light={!scrolled} /></Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium link-underline transition-colors ${
                  isActive ? "text-orange" : scrolled ? "text-charcoal hover:text-navy" : "text-white/80 hover:text-white"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a href={`tel:${COMPANY.phoneRaw}`} data-testid="nav-call"
             className={`flex items-center gap-2 text-sm font-semibold transition-colors ${scrolled ? "text-navy hover:text-orange" : "text-white hover:text-orange"}`}>
            <Phone size={16} strokeWidth={2} /> {COMPANY.phone}
          </a>
          <Link to="/quote" data-testid="nav-quote-btn"
                className="btn-orange px-5 py-2.5 text-sm font-semibold uppercase tracking-wide">
            Request a Quote
          </Link>
        </div>

        <button className={`lg:hidden ${scrolled ? "text-navy" : "text-white"}`} onClick={() => setOpen(!open)}
                data-testid="nav-mobile-toggle" aria-label="Toggle menu">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-navy text-white px-6 py-6 space-y-1" data-testid="mobile-menu">
          {NAV.map((item) => (
            <NavLink key={item.to} to={item.to}
                     className="block py-3 text-lg font-display font-semibold border-b border-white/10">
              {item.label}
            </NavLink>
          ))}
          <div className="pt-5 space-y-3">
            <a href={`tel:${COMPANY.phoneRaw}`} className="flex items-center gap-2 font-semibold text-orange">
              <Phone size={18} /> {COMPANY.phone}
            </a>
            <Link to="/quote" className="btn-orange block text-center px-5 py-3 font-semibold uppercase tracking-wide">
              Request a Quote
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
